import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-frontend-tech }}\n{{this.formatted}}",{ moduleName: "embercom/components/common/relative-datetime.hbs" })